import data from '../utils/Data';

const MapData = (state = data) => {
    return state
}

export default MapData;


// WEBPACK FOOTER //
// ./src/reducers/MapData.js